import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    evento: null,
    clienteNombre: '',
    eventoNombre: '',
    eventoWhapp: false,
    tipoEventoId: 0,
    eventoSorteado: false,
    registroManualHabilitado: false,
    solicitaCodigoPromocion: false,
    requiereDocumento: false,
    participacionNegocios: false,
    requiereInformacionBancaria: false,
    importaParticipantes: false,
    importaGanadores: false,
    camposAdicionales: [],
    /* Formato de la tabla */
    participantesColumnas: [],  
    tieneImportsPendientes: false,

    participantes: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    nombre: '',
    documentoNumero: '',
    email: '',
    numeroCelular: '',
    negocio: '',
    cuitNegocio: '',
    numeroCliente: '',
    codigoPromocion: '',

    nombreHabilitado: true,
    documentoNumeroHabilitado: true,
    emailHabilitado: true,
    numeroCelularHabilitado: true,
    negocioHabilitado: true,
    cuitNegocioHabilitado: true,
    numeroClienteHabilitado: true,
    codigoPromocionHabilitado: true,

    participanteDatos: [],
    participantesList: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_EVENTO' (state, eventoId) {
        state.eventoId = eventoId;
        state.evento = null;
        state.clienteNombre = '';
        state.eventoNombre = '';
        state.eventoWhapp = false;
        state.tipoEventoId = 0;
        state.requiereDocumento = false; 
        state.participacionNegocios = false; 
        state.requiereInformacionBancaria = false;
        state.camposAdicionales = [];
        state.participantesColumnas = [];

        state.participantes = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombreHabilitado = true;
        state.documentoNumeroHabilitado = false;
        state.emailHabilitado = false;
        state.numeroCelularHabilitado = false;
        state.negocioHabilitado = false;
        state.cuitNegocioHabilitado = false;
        state.numeroClienteHabilitado = false;
        state.codigoPromocionHabilitado = false;
    },
    'SET_EVENTO' (state, evento) {
        state.evento = evento;
        state.clienteNombre = evento.cliente;
        state.eventoNombre = evento.nombre;
        state.tipoEventoId = evento.tipoEventoId;
        state.eventoSorteado = (/true/i).test(evento.sorteado);
        state.registroManualHabilitado = (/true/i).test(evento.registroManualHabilitado);
        state.solicitaCodigoPromocion = (/true/i).test(evento.solicitaCodigoPromocion);
        state.requiereDocumento = (/true/i).test(evento.requiereDocumento);
        state.participacionNegocios = (/true/i).test(evento.participacionNegocios);
        state.requiereInformacionBancaria = (/true/i).test(evento.requiereInformacionBancaria);
        state.importaParticipantes = (/true/i).test(evento.importaParticipantes); 
        state.importaGanadores = (/true/i).test(evento.importaGanadores);
        state.camposAdicionales = evento.camposAdicionales;
        state.participantesColumnas = evento.participantesColumnas.sort((a, b) => {
            if (a.orden < b.orden) {
                return -1;
            }
            if (a.orden > b.orden) {
                return 1;
            }
            return 0;
        })

        state.tieneImportsPendientes = (/true/i).test(evento.tieneImportsPendientes);;

        state.nombreHabilitado = (/true/i).test(evento.solicitaNombre);
        state.documentoNumeroHabilitado = (/true/i).test(evento.solicitaDocumento);
        state.emailHabilitado = (/true/i).test(evento.solicitaEmail);
        state.numeroCelularHabilitado = (evento.tipoEventoId == 1 || (/true/i).test(evento.solicitaTelefono));
        state.negocioHabilitado = (/true/i).test(evento.participacionNegocios);
        state.cuitNegocioHabilitado = (/true/i).test(evento.solicitaDocumentoNegocio);
        state.codigoPromocionHabilitado = (/true/i).test(evento.solicitaCodigoPromocion);
        state.numeroClienteHabilitado = false;
    },
    'SET_PARTICIPANTES' (state, participantes) {
        state.participantes = participantes.map(participante => ({
            ...participante,
            _rowVariant: participante.staff ? 'staff' : ''
        }));

        /* Agregamos la lista de campos adicionales*/
        state.participantes.forEach(participante => {
            if (participante.camposAdicionales) {
                participante.camposAdicionales.forEach(campoAdicional => {
                    participante[`cp${campoAdicional.eventoCampoAdicionalId}`] = campoAdicional.valor;
                    
                });
            }
        });
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVENTO', eventoId);

            apiAxios.get(`eventos/${eventoId}`) 
                .then(res => {
                    commit('SET_EVENTO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    importarParticipantes ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_IMPORT');

            let error;
            let fileName = params.file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(params.file.size / 1048576);

            if (fileExtension != 'csv') {
                    error = 'El tipo de archivo seleccionado no es válido. Sólo se permiten archivos de tipo csv.';
            }

            if (fileSize >= 35 ) {
                error = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten archivos de hasta 35MB.';
            }

            if (error) {
                reject(error);
            } else {
				let formData = new FormData();
                formData.append('file', params.file);

                let options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }				

				apiAxios.post(`eventos/${state.eventoId}/participantes/sorteo/importar`, formData, options)
                    // .then(() =>  resolve())
                    .then(res => {
                        if (res.headers.pagination){
                            const pagination= JSON.parse(res.headers.pagination)
                            var params = {
                                paginaActual: pagination.currentPage,
                                registrosPorPagina: pagination.itemsPerPage,
                                totalRegistros: pagination.totalItems,
                                totalPaginas: pagination.totalPages,
                            }    
                            commit('SET_PAGINATION', params);
                        }
                        commit('SET_PARTICIPANTES', res.data);

                        resolve();
                    })
					.catch(error => reject(helpers.methods.getErrorMessage(error)));
			}
        })
    },
    getParticipantes ( { commit } ) {
        return new Promise((resolve, reject) => {
            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            if (state.nombre.trim() != '') {
                queryString += '&nombre=' + state.nombre.trim();
            }
            if (state.documentoNumero.trim() != '') {
                queryString += '&documentoNumero=' + state.documentoNumero.trim();
            }
            if (state.email.trim() != '') {
                queryString += '&email=' + state.email.trim();
            }
            if (state.numeroCelular.trim() != '') {
                queryString += '&numeroCelular=' + state.numeroCelular.trim();
            }
            if (state.negocio.trim() != '') {
                queryString += '&negocio=' + state.negocio.trim();
            }
            if (state.cuitNegocio.trim() != '') {
                queryString += '&cuitNegocio=' + state.cuitNegocio.trim();
            }
            if (state.codigoPromocion.trim() != '') {
                queryString += '&codigoPromocion=' + state.codigoPromocion.trim();
            }
            if (state.numeroCliente.trim() != '') {
                queryString += '&numeroCliente=' + state.numeroCliente.trim();
            }
            
            apiAxios.get(`eventos/${state.eventoId}/participantes/sorteo` + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_PARTICIPANTES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    sortear ( {} ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`eventos/${state.eventoId}/participantes/sorteo/sortear`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deleteImportacion ( {} ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`eventos/${state.eventoId}/participantes/sorteo/clear`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}